/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSum = createReactComponent("sum", "IconSum", [
  [
    "path",
    {
      d: "M18 16v2a1 1 0 0 1 -1 1h-11l6 -7l-6 -7h11a1 1 0 0 1 1 1v2",
      key: "svg-0"
    }
  ]
]);

export { IconSum as default };
//# sourceMappingURL=IconSum.js.map
